import React, { useMemo } from 'react';
import { ISnowfallItem } from 'api/resort/types';
import { BlockContent } from 'components/blocks/BlockContent';
import { SnowUnit } from 'components/blocks/Unit';
import { DateTime } from 'luxon';
import styles from './styles.module.scss';

export const BestTimeSnow = ({
  snowfallInfo,
}: {
  snowfallInfo: Array<ISnowfallItem>,
}) => {
  const lines = (() => {
    const maxValueLine = Math.max(...snowfallInfo.map((item) => item.totalSnow));
    const minValueLine = Math.min(...snowfallInfo.map((item) => item.totalSnow));

    return [
      Math.ceil(maxValueLine + (maxValueLine * 0.2)),
      Math.ceil(maxValueLine - (maxValueLine / 4)),
      Math.ceil(maxValueLine - (maxValueLine / 4) * 2),
      Math.ceil(maxValueLine - (maxValueLine / 4) * 3),
      minValueLine - (maxValueLine * 0.2) >= 0 ? Math.ceil(minValueLine - (maxValueLine * 0.2)) : minValueLine,
    ];
  })();
  const showMonth = (d: string) => {
    const date = DateTime.fromJSDate(new Date(d));

    return date.monthShort;
  };

  const filteredMonths = useMemo<Array<ISnowfallItem>>(
    () => {
      let isOneMonthWithoutSnow = false;
      return snowfallInfo.filter((item) => {
        if (item.totalSnow === 0) {
          if (!isOneMonthWithoutSnow) {
            isOneMonthWithoutSnow = true;
            return true;
          }
          return false;
        }
        return true;
      });
    },
    [snowfallInfo],
  );

  return (
    <div className={styles.bestTimeSnow}>
      <BlockContent className={styles.box}>
        <div className={styles.data}>
          {
              filteredMonths.map((snowfall) => (
                <div
                  key={snowfall.date}
                  className={styles.inner}
                  style={{ height: `${((snowfall.totalSnow * 100) / lines[0]).toFixed(0)}%` }}
                >
                  <div className={styles.value}>
                    <SnowUnit values={snowfall.totalSnow} />
                  </div>
                  <div className={styles.date}>{showMonth(snowfall.date)}</div>
                </div>
              ))
            }
        </div>
      </BlockContent>
    </div>
  );
};
